module.exports = __webpack_public_path__ + "static/media/video-icon.97302e37.jpg";